const initialState = {
    points: [],
    zones: [],
    branches: [],
    summary: {
        count: 0,
        revenue: 0
    },
    cellSize: 250,
    metric: 'count',
    showZones: false,
    filters: {
        createdStartDate: null,
        createdEndDate: null,
        points: []
    }
};

export default function deliveryMap(state = initialState, action) {
    switch (action.type) {
        case 'SET_DELIVERY_POINTS': {
            return {
                ...state,
                points: action.points,
                summary: action.summary,
                branches: action.branches || []
            };
        }
        case 'SET_DELIVERY_ZONES': {
            return {
                ...state,
                zones: action.zones || []
            };
        }
        case 'SET_DELIVERY_SHOW_ZONES': {
            return {
                ...state,
                showZones: action.showZones
            };
        }
        case 'SET_DELIVERY_FILTERS': {
            return {
                ...state,
                filters: action.filters
            };
        }
        case 'SET_DELIVERY_CELL_SIZE': {
            return {
                ...state,
                cellSize: action.cellSize
            };
        }
        case 'SET_DELIVERY_METRIC': {
            return {
                ...state,
                metric: action.metric
            };
        }
        default:
            return state;
    }
}
